import React, { FunctionComponent } from 'react'
import { Grid, Link, Text } from '@afterpaytouch/core'
import { useConsumerSizes } from '../../utils/responsive'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import styles from './style.module.css'
import { useTranslation } from 'next-i18next'
import { Route } from '../../config/router'
import { Gravatar } from '../Gravatar'
import { TrackingEvent } from '../../model/amplitude'
import { useAppRouter, useLogout } from '../../state'
import { useAmplitudeWithEnduringEventProperties } from '../../integrations/amplitude'

interface ProfileCardProps {
  consumerEmail: string
  consumerName: string
  allowLogout?: boolean
}

const I18N_NAMESPACE = ['common']

export const ProfileCard: FunctionComponent<ProfileCardProps> = ({ consumerEmail, consumerName, allowLogout = false }) => {
  const { textSize, smallTextSize } = useConsumerSizes()
  const { t } = useTranslation(I18N_NAMESPACE)
  const logout = useLogout(false)
  const router = useAppRouter()
  const { logEvent } = useAmplitudeWithEnduringEventProperties()

  const handleClickNotYou = (): void => {
    logEvent(TrackingEvent.CLICKED_NOT_YOU)
    logout()
    router.push(Route.INDEX)
  }
  const renderNotYou = (): JSX.Element => {
    return (
      <Text size={smallTextSize} renderAs='span'>
        <Link onClick={handleClickNotYou} kind='Underline'>
          {t('common:notYou')}
        </Link>
      </Text>
    )
  }

  return (
    <Grid>
      <MaskedElement>
        <div className={styles.profileCard}>
          <Gravatar size='M' alt={consumerName} name={consumerName} title={consumerName} />
          <div className='overflow-hidden'>
            <Text size={textSize} renderAs='div'>
              <div className={styles.variableColumn}>
                <Text size='M' bold>
                  {allowLogout ? consumerEmail : consumerName}
                </Text>
              </div>
              <div className={styles.variableColumn}>
                {allowLogout && renderNotYou()}
                {!allowLogout && (
                  <Text size={smallTextSize} renderAs='span' color='Gray50' testNameSpace='consumer-email'>
                    {consumerEmail}
                  </Text>
                )}
              </div>
            </Text>
          </div>
        </div>
      </MaskedElement>
    </Grid>
  )
}
